"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ClassStateService = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _ampApi = require("@amplify/amp-api");

var _realtimeService = _interopRequireDefault(require("./realtimeService"));

var _classroomOrchestrationService = _interopRequireDefault(require("./classroomOrchestrationService"));

var _monitoringService = _interopRequireDefault(require("./monitoringService"));

var _xApiEventService = _interopRequireDefault(require("./xApiEventService"));

var _constants = require("../shared/constants");

var _logger = _interopRequireDefault(require("../utils/logger"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DEFAULT_STATE = {
  activeClass: undefined,
  isEyesUpActive: undefined,
  classLocation: undefined,
  classPacing: undefined,
  primaryTeacherKey: undefined,
  isPrimaryTeacherPresent: undefined,
  allStartedClasses: [],
  classSessionId: undefined
};
var DEFAULT_OPTIONS = {
  trackPresenceOnClassStart: true
};
var VISIBILITY_CHANGE_EVENT = 'visibilitychange';

var ClassStateService = /*#__PURE__*/function () {
  function ClassStateService() {
    (0, _classCallCheck2.default)(this, ClassStateService);
    (0, _defineProperty2.default)(this, "state", void 0);
    (0, _defineProperty2.default)(this, "channels", void 0);
    (0, _defineProperty2.default)(this, "userId", void 0);
    (0, _defineProperty2.default)(this, "isStudent", false);
    (0, _defineProperty2.default)(this, "isTeacher", false);
    (0, _defineProperty2.default)(this, "trackPresenceOnClassStart", false);
    (0, _defineProperty2.default)(this, "classCache", void 0);
    (0, _defineProperty2.default)(this, "allStartedClasses", void 0);
    (0, _defineProperty2.default)(this, "stateChangeCallbacks", void 0);
    (0, _defineProperty2.default)(this, "classExpirationCallbacks", void 0);
    (0, _defineProperty2.default)(this, "activeClassTtlTimeout", void 0);
    (0, _defineProperty2.default)(this, "heartbeatInterval", void 0);
    (0, _defineProperty2.default)(this, "cachedPrevState", void 0);
    (0, _defineProperty2.default)(this, "eventingCache", {});
    this.state = _lodash.default.cloneDeep(DEFAULT_STATE);
    this.channels = [];
    this.classCache = {};
    this.allStartedClasses = [];
    this.stateChangeCallbacks = [];
    this.classExpirationCallbacks = [];
    this.activeClassTtlTimeout = null;
    this.heartbeatInterval = null;
    this.handleClassStatusUpdate = this.handleClassStatusUpdate.bind(this);
    this.handleEyesUpStatusUpdate = this.handleEyesUpStatusUpdate.bind(this);
    this.handleClassContentLocationUpdate = this.handleClassContentLocationUpdate.bind(this);
    this.handlePresence = this.handlePresence.bind(this);
    this.handleClassPacingUpdate = this.handleClassPacingUpdate.bind(this);
    this.triggerStateChangeCallbacks = _lodash.default.debounce(this.triggerStateChangeCallbacks.bind(this), 100);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }
  /**
   * Initialize the service. Subscribe to class channels and listen for class state realtime notifications.
   */


  (0, _createClass2.default)(ClassStateService, [{
    key: "init",
    value: function init(classKeys, userRole) {
      var _this = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.channels = classKeys;
      this.isStudent = userRole === _constants.ROLES.STUDENT;
      this.isTeacher = userRole === _constants.ROLES.TEACHER;
      options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
      this.trackPresenceOnClassStart = this.isTeacher && options.trackPresenceOnClassStart; // Subscribe with presence on init if trackPresenceOnClassStart is disabled

      this.subscribeToChannels(this.channels, this.isTeacher && !this.trackPresenceOnClassStart);

      _classroomOrchestrationService.default.addListenerForClassStatus(this.channels, this.handleClassStatusUpdate);

      _classroomOrchestrationService.default.addListenerForEyesUpStatus(this.channels, this.handleEyesUpStatusUpdate);

      _classroomOrchestrationService.default.addListenerForClassContentLocation(this.channels, this.handleClassContentLocationUpdate);

      _classroomOrchestrationService.default.addListenerForClassPacing(this.channels, this.handleClassPacingUpdate);

      if (this.isTeacher) {
        this.channels.forEach(function (channel) {
          _realtimeService.default.addPresenceListener(channel, _this.handlePresence); // set primary teacher presence on service init


          _realtimeService.default.getCurrentSubscribers(channel).then(function (uuids) {
            _this.updatePrimaryTeacherPresence(uuids, true);
          });
        });
      }

      document.addEventListener(VISIBILITY_CHANGE_EVENT, this.onVisibilityChange, false);
    }
    /**
     * Register a callback that will be triggered whenever the class state changes.
     */

  }, {
    key: "registerStateChangeCallback",
    value: function registerStateChangeCallback(callback) {
      this.stateChangeCallbacks.push(callback);
    }
    /**
     * Unregister a state change callback.
     */

  }, {
    key: "unregisterStateChangeCallback",
    value: function unregisterStateChangeCallback(callback) {
      this.stateChangeCallbacks = _lodash.default.without(this.stateChangeCallbacks, callback);
    }
    /**
     * Destroy all realtime connections, clear the state, and clear callbacks.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this.state = _lodash.default.cloneDeep(DEFAULT_STATE);
      this.classCache = {};
      this.allStartedClasses = [];
      this.stateChangeCallbacks = [];
      this.classExpirationCallbacks = [];
      this.activeClassTtlTimeout = null;
      this.cachedPrevState = null;
      this.eventingCache = {};

      _realtimeService.default.unsubscribeFromChannels(this.channels, _constants.SUBSCRIPTION_OWNERS.CLASS_STATE_SERVICE);

      _classroomOrchestrationService.default.removeListenerForClassStatus(this.handleClassStatusUpdate);

      _classroomOrchestrationService.default.removeListenerForEyesUpStatus(this.handleEyesUpStatusUpdate);

      _classroomOrchestrationService.default.removeListenerForClassContentLocation(this.handleClassContentLocationUpdate);

      _classroomOrchestrationService.default.removeListenerForClassPacing(this.handleClassPacingUpdate);

      if (this.isTeacher) {
        this.channels.forEach(function (channel) {
          _realtimeService.default.removePresenceListener(channel, _this2.handlePresence);
        });
      }

      this.channels = [];
      document.removeEventListener(VISIBILITY_CHANGE_EVENT, this.onVisibilityChange);
    }
    /**
     * Start a class. Can only be called by teachers.
     * Publishes a realtime message updating the class status.
     *
     * Deactivates eyes-up in case it was left active in a previous session (can happen when class expires while eyes-up
     * is active). If isEyesUpActive value is passed, this will be used instead.
     */

  }, {
    key: "startClass",
    value: function startClass(classKey) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          isEyesUpActive = _ref.isEyesUpActive,
          classPacing = _ref.classPacing;

      if (!this.isTeacher) {
        _logger.default.warn('Only teachers can call startClass');

        return Promise.resolve();
      } else {
        var tabId = this.getTabId(true);
        var classSessionId = this.generateClassSessionId();
        this.eventingCache.teacherTriggeredStartClass = true;
        this.addToStartedClasses(classKey);
        this.updateClassCache(classKey, {
          isEyesUpActive: isEyesUpActive !== null && isEyesUpActive !== void 0 ? isEyesUpActive : false,
          primaryTeacherKey: this.userId,
          managingTabId: tabId,
          classPacing: classPacing,
          classSessionId: classSessionId
        });
        this.joinClass(classKey);
        var promises = [_classroomOrchestrationService.default.publishClassStatus(classKey, true, tabId, classSessionId), this.setEyesUpStatus(isEyesUpActive !== null && isEyesUpActive !== void 0 ? isEyesUpActive : false)];

        if (classPacing) {
          promises.push(this.setClassPacing(classPacing));
        }

        return Promise.all(promises);
      }
    }
    /**
     * End the active class. Can only be called by teachers.
     * Publishes realtime messages updating the class status; and clearing eyes-up, class location, and class pacing.
     */

  }, {
    key: "endClass",
    value: function endClass(classKey) {
      var classToEnd = classKey ? classKey : this.state.activeClass;

      if (!this.isTeacher) {
        _logger.default.warn('Only teachers can call endClass');

        return Promise.resolve();
      } else if (classToEnd) {
        this.eventingCache.teacherTriggeredEndClass = true;
        this.removeFromStartedClasses(classToEnd);
        this.saveJoinedStatus(classToEnd, false);

        if (classKey && classKey !== this.state.activeClass) {
          this.updateState({
            allStartedClasses: this.allStartedClasses
          });
        } else {
          this.leaveClass();
        }

        this.clearHeartbeatInterval();
        return Promise.all([_classroomOrchestrationService.default.publishClassStatus(classToEnd, false, this.getTabId()), _classroomOrchestrationService.default.publishClassEyesUpStatus(classToEnd, false), _classroomOrchestrationService.default.publishClassContentLocation(classToEnd, null), _classroomOrchestrationService.default.publishClassPacing(classToEnd, {})]);
      } else {
        return Promise.resolve();
      }
    }
    /**
     * Join a class. This will become the user's active class, and updates to this class
     * will be reflected in the state.
     */

  }, {
    key: "joinClass",
    value: function joinClass(classKey) {
      if (this.state.activeClass !== classKey) {
        this.leaveClass();
      } // Re-subscribe with presence to the active class.


      if (this.trackPresenceOnClassStart) {
        this.subscribeToChannels(classKey, true);
      }

      var cachedClass = this.classCache[classKey] || {};
      this.updateState({
        activeClass: classKey,
        isEyesUpActive: cachedClass.isEyesUpActive,
        classLocation: cachedClass.classLocation,
        classPacing: cachedClass.classPacing,
        primaryTeacherKey: cachedClass.primaryTeacherKey,
        isPrimaryTeacherPresent: cachedClass.isPrimaryTeacherPresent,
        classSessionId: cachedClass.classSessionId,
        allStartedClasses: this.allStartedClasses
      }); // If the teacher is rejoining their own class session in the tab that
      // is managing the class session (generally this is a refresh) then we
      // reinstate the class session heartbeat to keep it alive.
      // For backwards compatibility we also start the heartbeat if there is no tabId pinned to
      // the class session.

      if (this.isTeacher && cachedClass.primaryTeacherKey === this.userId && (!cachedClass.managingTabId || cachedClass.managingTabId === this.getTabId())) {
        this.setHeartbeatInterval(classKey);
      } // If this is a co-teacher, save their joined status.


      if (this.isTeacher && cachedClass.primaryTeacherKey !== this.userId) {
        this.saveJoinedStatus(classKey, true);
      }

      _monitoringService.default.reportAction('Joined class session', classKey);
    }
    /**
     * Leave the current active class. The active class properties of the state will be
     * cleared and remain clear until another class is joined.
     */

  }, {
    key: "leaveClass",
    value: function leaveClass() {
      var classKey = this.state.activeClass;

      if (classKey) {
        // Re-subscribe without presence to the non-active class.
        if (this.trackPresenceOnClassStart) {
          this.subscribeToChannels(classKey, false);
        } // If this is a co-teacher, save their joined status.


        if (this.isTeacher && this.state.primaryTeacherKey !== this.userId) {
          this.saveJoinedStatus(classKey, false);
        }

        this.updateState(_objectSpread(_objectSpread({}, DEFAULT_STATE), {}, {
          allStartedClasses: this.allStartedClasses
        }));
        this.clearHeartbeatInterval();
        this.clearActiveClassTtlTimeout();
      }

      _monitoringService.default.reportAction('Leave class session', classKey);
    }
    /**
     * Set eyes-up status for the active class. Can only be called by teachers.
     * Publishes a realtime message updating the class eyes-up status.
     */

  }, {
    key: "setEyesUpStatus",
    value: function setEyesUpStatus(isEyesUpActive) {
      if (!this.isTeacher) {
        _logger.default.warn('Only teachers can call setEyesUpStatus');

        return Promise.resolve();
      } else if (!this.state.activeClass) {
        _logger.default.warn('Cannot set eyes-up status because there is no active class');

        return Promise.resolve();
      } else {
        this.updateState({
          isEyesUpActive: isEyesUpActive
        });
        return _classroomOrchestrationService.default.publishClassEyesUpStatus(this.state.activeClass, isEyesUpActive);
      }
    }
    /**
     * Set content location for the active class. Can only be called by teachers.
     * Publishes a realtime message updating the class content location.
     */

  }, {
    key: "setClassLocation",
    value: function setClassLocation(classLocation) {
      if (!this.isTeacher) {
        _logger.default.warn('Only teachers can call setClassLocation');

        return Promise.resolve();
      } else if (!this.state.activeClass) {
        _logger.default.warn('Cannot set class location because there is no active class');

        return Promise.resolve();
      } else {
        this.updateState({
          classLocation: classLocation
        });
        return _classroomOrchestrationService.default.publishClassContentLocation(this.state.activeClass, classLocation);
      }
    }
    /**
     * Set class pacing for the active class. Can only be called by teachers.
     * Publishes a realtime message updating the class pacing.
     */

  }, {
    key: "setClassPacing",
    value: function setClassPacing(classPacing) {
      if (!this.isTeacher) {
        _logger.default.warn('Only teachers can call setClassPacing');

        return Promise.resolve();
      } else if (!this.state.activeClass) {
        _logger.default.warn('Cannot set class pacing because there is no active class');

        return Promise.resolve();
      } else {
        this.updateState({
          classPacing: classPacing
        });
        return _classroomOrchestrationService.default.publishClassPacing(this.state.activeClass, classPacing);
      }
    }
    /**
     * Register a callback that will be triggered if the active class expires.
     */

  }, {
    key: "registerClassExpirationCallback",
    value: function registerClassExpirationCallback(callback) {
      this.classExpirationCallbacks.push(callback);
    }
    /**
     * Unregister a class expiration callback.
     */

  }, {
    key: "unregisterClassExpirationCallback",
    value: function unregisterClassExpirationCallback(callback) {
      this.classExpirationCallbacks = _lodash.default.without(this.classExpirationCallbacks, callback);
    }
    /**
     * Return any known data about a class, whether it is the active class or not.
     */

  }, {
    key: "getClassData",
    value: function getClassData(classKey) {
      return _lodash.default.omit(this.classCache[classKey] || {}, 'ttl');
    }
  }, {
    key: "updateState",
    value: function updateState(stateDelta) {
      var prevState = _lodash.default.cloneDeep(this.state);

      this.cachedPrevState = this.cachedPrevState || prevState;
      this.state = _objectSpread(_objectSpread({}, this.state), stateDelta);
      this.triggerStateChangeCallbacks();

      if (this.state.activeClass) {
        this.triggerClassStartEvents(prevState, stateDelta);
      } else {
        this.triggerClassEndEvents(prevState, stateDelta);
      }
    }
  }, {
    key: "triggerStateChangeCallbacks",
    value: function triggerStateChangeCallbacks() {
      var _this3 = this;

      if (!_lodash.default.isEqual(this.cachedPrevState, this.state)) {
        this.stateChangeCallbacks.forEach(function (callback) {
          callback(_this3.state, _this3.cachedPrevState);
        });
      }

      this.cachedPrevState = null;
    }
  }, {
    key: "updateClassCache",
    value: function updateClassCache(classKey, classDelta) {
      var cachedClass = this.classCache[classKey] || {
        businessKey: classKey
      };
      this.classCache[classKey] = _objectSpread(_objectSpread({}, cachedClass), classDelta);
    }
  }, {
    key: "addToStartedClasses",
    value: function addToStartedClasses(classKey) {
      if (!this.allStartedClasses.includes(classKey)) {
        this.allStartedClasses = this.allStartedClasses.concat([classKey]);
      }
    }
  }, {
    key: "removeFromStartedClasses",
    value: function removeFromStartedClasses(classKey) {
      this.allStartedClasses = this.allStartedClasses.filter(function (key) {
        return key !== classKey;
      });
    }
    /**
     * Set a TTL timeout for the active class. Leave the class when the timeout is reached.
     * If the client has registered an expiration callback, this will be called if the timeout is reached.
     */

  }, {
    key: "setActiveClassTtlTimeout",
    value: function setActiveClassTtlTimeout() {
      var _this4 = this;

      this.clearActiveClassTtlTimeout();
      var activeClass = this.state.activeClass;
      var ttl = this.classCache[activeClass].ttl;
      this.activeClassTtlTimeout = setTimeout(function () {
        _this4.triggerClassTimeoutEvent();

        _this4.removeFromStartedClasses(activeClass);

        _this4.leaveClass();

        _this4.classExpirationCallbacks.forEach(function (callback) {
          callback(activeClass);
        });

        _this4.activeClassTtlTimeout = null;

        _monitoringService.default.reportWarning('Class session was timed out', activeClass);
      }, ttl);
    }
  }, {
    key: "clearActiveClassTtlTimeout",
    value: function clearActiveClassTtlTimeout() {
      if (this.activeClassTtlTimeout) {
        window.clearTimeout(this.activeClassTtlTimeout);
        this.activeClassTtlTimeout = null;
      }
    }
  }, {
    key: "setHeartbeatInterval",
    value: function setHeartbeatInterval(classKey) {
      var _this5 = this;

      this.clearHeartbeatInterval();
      this.heartbeatInterval = window.setInterval(function () {
        _classroomOrchestrationService.default.publishClassStatus(classKey, true, _this5.getTabId(), _this5.state.classSessionId, undefined, true);
      }, _constants.HEARTBEAT_INTERVAL);
    }
  }, {
    key: "clearHeartbeatInterval",
    value: function clearHeartbeatInterval() {
      if (this.heartbeatInterval) {
        window.clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    }
    /**
     * Save the user's joined class status to aws-storage-service.
     * Will be used to determine if co-teacher should automatically re-join a class.
     */

  }, {
    key: "saveJoinedStatus",
    value: function saveJoinedStatus(classKey, hasJoined) {
      (0, _ampApi.saveUserFile)(this.userId, "joinedStatus-".concat(classKey), {
        hasJoined: hasJoined
      });
    }
    /**
     * Fetch the user's joined class status from aws-storage-service.
     */

  }, {
    key: "fetchJoinedStatus",
    value: function fetchJoinedStatus(classKey) {
      return (0, _ampApi.fetchUserFile)(this.userId, "joinedStatus-".concat(classKey));
    }
    /**
     * Listen for class status changes, and update the cached status data for the class.
     * Trigger state updates as appropriate.
     */

  }, {
    key: "handleClassStatusUpdate",
    value: function () {
      var _handleClassStatusUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(classKey, payload, publisherId, wasDirectPayload) {
        var cachedClass, status, activeTeacherKey, updatedOn, ttl, managingTabId, classSessionId, isStarted, primaryTeacherKey, isPrimaryTeacherPresent, currentSubscribers, _status, stateUpdate;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!payload.isExpired) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                cachedClass = this.classCache[classKey];
                status = payload.status, activeTeacherKey = payload.activeTeacherKey, updatedOn = payload.updatedOn, ttl = payload.ttl, managingTabId = payload.managingTabId, classSessionId = payload.classSessionId;
                isStarted = status === _constants.CLASS_STATUSES.STARTED; // direct payloads are not permitted to update class status
                // we do this because message order is not necessarily guaranteed

                if (!(wasDirectPayload && (cachedClass === null || cachedClass === void 0 ? void 0 : cachedClass.isStarted) !== isStarted)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                primaryTeacherKey = isStarted ? activeTeacherKey : null;

                if (!this.isTeacher) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return _realtimeService.default.getCurrentSubscribers(classKey);

              case 11:
                currentSubscribers = _context.sent;
                isPrimaryTeacherPresent = currentSubscribers.includes(primaryTeacherKey);

              case 13:
                this.updateClassCache(classKey, {
                  isStarted: isStarted,
                  primaryTeacherKey: primaryTeacherKey,
                  isPrimaryTeacherPresent: isPrimaryTeacherPresent,
                  updatedOn: updatedOn,
                  ttl: ttl,
                  managingTabId: managingTabId,
                  classSessionId: classSessionId
                });

                if (!isStarted) {
                  _context.next = 24;
                  break;
                }

                this.addToStartedClasses(classKey); // Class should automatically be active for the teacher who started it.

                if (!this.state.activeClass && this.isTeacher && activeTeacherKey === this.userId) {
                  this.joinClass(classKey);
                } // Class should automatically be active if this teacher previously joined as a co-teacher.


                if (!(!this.state.activeClass && this.isTeacher && activeTeacherKey !== this.userId)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 20;
                return this.fetchJoinedStatus(classKey);

              case 20:
                _status = _context.sent;

                if (_status && _status.hasJoined) {
                  this.joinClass(classKey);
                }

              case 22:
                _context.next = 26;
                break;

              case 24:
                this.removeFromStartedClasses(classKey);

                if (this.state.activeClass === classKey) {
                  this.leaveClass();
                }

              case 26:
                // Class should automatically be active for a student if it's their only started class.
                if (this.isStudent && _lodash.default.isNil(this.state.activeClass) && this.allStartedClasses.length === 1) {
                  this.joinClass(this.allStartedClasses[0]);
                } // If this is an update for the active class, make sure TTL timeout is set.


                if (this.state.activeClass === classKey) {
                  this.setActiveClassTtlTimeout();
                }

                stateUpdate = {
                  allStartedClasses: this.allStartedClasses
                };

                if (this.state.activeClass === classKey && this.state.primaryTeacherKey !== primaryTeacherKey) {
                  stateUpdate.primaryTeacherKey = primaryTeacherKey;
                }

                this.updateState(stateUpdate);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleClassStatusUpdate(_x, _x2, _x3, _x4) {
        return _handleClassStatusUpdate.apply(this, arguments);
      }

      return handleClassStatusUpdate;
    }()
    /**
     * Listen for eyes-up status changes, and update the cached eyes-up status for the class.
     * If this is the active class, also update the state.
     */

  }, {
    key: "handleEyesUpStatusUpdate",
    value: function handleEyesUpStatusUpdate(classKey, payload) {
      var isEyesUpActive = payload.eyesUpStatus === _constants.EYES_UP_STATUSES.ACTIVE;
      this.updateClassCache(classKey, {
        isEyesUpActive: isEyesUpActive
      });

      if (this.state.activeClass === classKey) {
        this.updateState({
          isEyesUpActive: isEyesUpActive
        });
      }
    }
    /**
     * Listen for class location changes, and update the cached location for the class.
     * If this is the active class, also update the state.
     */

  }, {
    key: "handleClassContentLocationUpdate",
    value: function handleClassContentLocationUpdate(classKey, payload) {
      var classLocation = payload.contentBreadcrumb;
      this.updateClassCache(classKey, {
        classLocation: classLocation
      });

      if (this.state.activeClass === classKey) {
        this.updateState({
          classLocation: classLocation
        });
      }
    }
    /**
     * Listen for class pacing changes, and update the cached pacing for the class.
     * If this is the active class, also update the state.
     */

  }, {
    key: "handleClassPacingUpdate",
    value: function handleClassPacingUpdate(classKey, payload) {
      var classPacing = payload.classPacing;
      this.updateClassCache(classKey, {
        classPacing: classPacing
      });

      if (this.state.activeClass === classKey) {
        this.updateState({
          classPacing: classPacing
        });
      }
    }
    /**
     * Listen for user presence on the channel, and update cached isPrimaryTeacherPresent values for any
     * class whose primary teacher's presence changes. If primary teacher presence changes for the active
     * class, also update the state.
     */

  }, {
    key: "handlePresence",
    value: function handlePresence(classKey, payload, userId) {
      var isPresent = payload.action === _constants.PRESENCE_ACTIONS.JOIN;
      this.updatePrimaryTeacherPresence(userId, isPresent);
    }
    /**
     * Update presence of primary teacher in class cache and state
     */

  }, {
    key: "updatePrimaryTeacherPresence",
    value: function updatePrimaryTeacherPresence(userIds, isPresent) {
      var _this6 = this;

      var uuids = Array.isArray(userIds) ? userIds : [userIds];

      _lodash.default.forEach(this.classCache, function (classData, classKey) {
        if (uuids.includes(classData.primaryTeacherKey) && classData.isPrimaryTeacherPresent !== isPresent) {
          _this6.updateClassCache(classKey, {
            isPrimaryTeacherPresent: isPresent
          });
        }
      });

      if (uuids.includes(this.state.primaryTeacherKey) && this.state.isPrimaryTeacherPresent !== isPresent) {
        this.updateState({
          isPrimaryTeacherPresent: isPresent
        });
      }
    }
    /**
     * Subscribe to channels as ClassStateService.
     */

  }, {
    key: "subscribeToChannels",
    value: function subscribeToChannels(channelNames, withPresence) {
      _realtimeService.default.subscribeToChannels(channelNames, withPresence, _constants.SUBSCRIPTION_OWNERS.CLASS_STATE_SERVICE);
    }
    /**
     * Retrieve or create a new tabId that is a unique identifier for
     * the domain and browser tab based on a uuid stored in sessionStorage
     */

  }, {
    key: "getTabId",
    value: function getTabId() {
      var forceRegen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var tabId = window.sessionStorage.getItem(_constants.TAB_ID_STORAGE_KEY);

      if (!tabId || forceRegen) {
        tabId = (0, _v.default)();
        window.sessionStorage.setItem(_constants.TAB_ID_STORAGE_KEY, tabId);
      }

      return tabId;
    }
    /**
     * Create a new classSessionId that is a unique identifier for
     * the current started class session based
     */

  }, {
    key: "generateClassSessionId",
    value: function generateClassSessionId() {
      return "classSessionId_".concat((0, _v.default)());
    }
    /**
     * Handle visibility change - used to trigger resync when browser awakes
     */

  }, {
    key: "onVisibilityChange",
    value: function onVisibilityChange() {
      if (document.hidden === false) {
        _classroomOrchestrationService.default.forceClassRecordReSync();
      }
    }
    /**
     * Trigger xAPI eventing when active class state data is first fully set.
     */

  }, {
    key: "triggerClassStartEvents",
    value: function triggerClassStartEvents(prevState, stateDelta) {
      var isClassStart = prevState.activeClass !== stateDelta.activeClass && !_lodash.default.isNil(stateDelta.activeClass) || _lodash.default.isEmpty(prevState.classLocation) && !_lodash.default.isEmpty(stateDelta.classLocation) || _lodash.default.isEmpty(prevState.classPacing) && !_lodash.default.isEmpty(stateDelta.classPacing);

      if (isClassStart) {
        var isStateReady = !_lodash.default.isNil(this.state.activeClass) && !_lodash.default.isEmpty(this.state.classLocation) && !_lodash.default.isEmpty(this.state.classPacing);

        if (isStateReady) {
          var eventContext = this.getEventContextFromState(this.state);
          var isPrimaryTeacher = this.isTeacher && this.state.primaryTeacherKey === this.userId;

          if (isPrimaryTeacher) {
            if (this.eventingCache.teacherTriggeredStartClass) {
              this.eventingCache.teacherTriggeredStartClass = false;

              _xApiEventService.default.logStartClass(eventContext);
            }
          } else {
            _xApiEventService.default.logJoinClass(eventContext);
          }
        }
      }
    }
    /**
     * Trigger xAPI eventing when class becomes inactive.
     */

  }, {
    key: "triggerClassEndEvents",
    value: function triggerClassEndEvents(prevState, stateDelta) {
      var isClassEnd = !_lodash.default.isNil(prevState.activeClass) && _lodash.default.isNil(stateDelta.activeClass);

      if (isClassEnd) {
        var eventContext = this.getEventContextFromState(prevState);
        var isPrimaryTeacher = this.isTeacher && prevState.primaryTeacherKey === this.userId;

        if (isPrimaryTeacher) {
          if (this.eventingCache.teacherTriggeredEndClass) {
            this.eventingCache.teacherTriggeredEndClass = false;

            _xApiEventService.default.logEndClass(eventContext);
          }
        } else {
          _xApiEventService.default.logLeaveClass(eventContext);
        }
      }
    }
    /**
     * Trigger xAPI eventing when class session times out.
     */

  }, {
    key: "triggerClassTimeoutEvent",
    value: function triggerClassTimeoutEvent() {
      var eventContext = this.getEventContextFromState(this.state);

      _xApiEventService.default.logClassTimeout(eventContext);
    }
  }, {
    key: "getEventContextFromState",
    value: function getEventContextFromState(state) {
      var _state$classPacing;

      return _objectSpread(_objectSpread({}, state.classLocation || {}), {}, {
        classKey: state.activeClass,
        pacingMode: (_state$classPacing = state.classPacing) === null || _state$classPacing === void 0 ? void 0 : _state$classPacing.pacingMode,
        classSessionId: state.classSessionId
      });
    }
  }]);
  return ClassStateService;
}();

exports.ClassStateService = ClassStateService;

var _default = new ClassStateService();

exports.default = _default;
//# sourceMappingURL=classStateService.js.map